module.exports = __webpack_public_path__ + "static/media/bhavini.42d0ff9e.jpg";